import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import MainLayout from 'components/MainLayout'
import { Container } from 'components/layout/Grid/'
import BackToAdminCentre from 'components/BackToAdminCentre'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { getBeneficiaryUpload, lockBeneficiary, sendNotification } from 'actions/beneficiaryUpload'
import { hasAccess } from 'utils/hasAccess'

class BeneficiaryUpload extends Component {
  static propTypes = {
    currentUser: PropTypes.object,
    getBeneficiaryUpload: PropTypes.func.isRequired,
    beneficiaryUpload: PropTypes.object.isRequired,
    lockBeneficiary: PropTypes.func.isRequired,
    routes: PropTypes.instanceOf(Array),
    sendNotification: PropTypes.func.isRequired,
    setErrorMessage: PropTypes.func.isRequired,
  }
  static defaultProps = {
    routes: {},
    currentUser: null,
  }

  componentDidMount() {
    hasAccess(this.props.currentUser, 'ADMN: Upload beneficiary', this.props.history, 'RW', true)
    this.props.getBeneficiaryUpload()
  }

  bannerProps = () => {
    const {
      routes, history, location, match, path,
    } = this.props
    return {
      name: 'Admin centre',
      history,
      location,
      path,
      match,
      routes,
    }
  }

  render() {
    const {
      routes, beneficiaryUpload, currentUser,
    } = this.props

    return (
      <MainLayout bannerNavProps={{ ...this.bannerProps() }} showSidebar={false} sidebarType="partnerSideBar">
        <BackToAdminCentre displayText="Upload beneficiary" isAdmin={this.props.currentUser.IsAdmin} />
        <Container>
          {routes.map((route, i) => (
            <RouteWithSubRoutes
              key={i}
              {...route}
              currentUser={currentUser}
              initUpload={this.props.getBeneficiaryUpload}
              beneficiaryUpload={beneficiaryUpload}
              sendNotification={this.props.sendNotification}
              lockBeneficiary={this.props.lockBeneficiary}
              setErrorMessage={this.props.setErrorMessage}
            />
            ))}
        </Container>
      </MainLayout>
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  beneficiaryUpload: state.beneficiaryUpload,
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  sendNotification,
  getBeneficiaryUpload,
  lockBeneficiary,
})(BeneficiaryUpload))



// WEBPACK FOOTER //
// ./src/containers/BeneficiaryUpload.js